module.exports = __webpack_public_path__ + "static/hp-father-and-child.868cb8c5.webp";